import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    fontFamily: 'Inter',
    boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.07)',
    borderRadius: '12px',
    marginTop: '25px'
  },

  contentContainer: {
    padding: '18px 15px 18px 15px',
    background: 'white',
    borderRadius: '0px 0px 12px 12px',

  },
  content: {
    maxHeight: '236px',
    overflowY: 'auto'
  },
  emptyContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '192px',
    borderRadius: '12px',
    background: theme.palette.primary.primary50,
    cursor: 'pointer',
    '&:hover': {
      background: theme.palette.primary.primary100
    },
    '&:active': {
      background: theme.palette.primary.primary200
    }
  },
  emptyContentTitle: {
    color: theme.palette.primary.primary800,
    fontSize: '16px',
    fontWeight: 600
  },
  addAttribute: {
    marginTop: '20px'
  },
  attributWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    marginBottom: '14px',
  },
  attributInfos: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '24px',
    background: '#FFF',
    boxShadow: '0px 6px 16px 0px rgba(21, 12, 115, 0.06)',
    width: 'fit-content',
    height: '30px',
    padding: '0px 13px 0px 0px',
    cursor: 'pointer',
  },
  attributLibelle: {
    borderRadius: '24px 0px 0px 24px',
    background: theme.palette.primary.primary200,
    padding: '6px 13px',
    fontSize: '14px',
    color: theme.palette.black.dark,
    fontWeight: 600,
    whiteSpace: 'nowrap'
  },
  attributType: {
    padding: '6px 13px',
    fontSize: '14px',
    color: theme.palette.grey.grey400,
    whiteSpace: 'nowrap'
  },
  deleteAttributButton: {
    height: '15px',
    cursor: 'pointer',
    marginLeft: '10px',
  }
}));

export default useStyles;